var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExtend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.76465 1.24011V4.24011C6.76465 4.77055 6.55393 5.27925 6.17886 5.65433C5.80379 6.0294 5.29508 6.24011 4.76465 6.24011H1.76465M19.7646 6.24011H16.7646C16.2342 6.24011 15.7255 6.0294 15.3504 5.65433C14.9754 5.27925 14.7646 4.77055 14.7646 4.24011V1.24011M14.7646 19.2401V16.2401C14.7646 15.7097 14.9754 15.201 15.3504 14.8259C15.7255 14.4508 16.2342 14.2401 16.7646 14.2401H19.7646M1.76465 14.2401H4.76465C5.29508 14.2401 5.80379 14.4508 6.17886 14.8259C6.55393 15.201 6.76465 15.7097 6.76465 16.2401V19.2401",
    stroke: "#808080",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtend);
export default __webpack_public_path__ + "static/media/extend.c36261b96ddaaaf2b3672daf97111157.svg";
export { ForwardRef as ReactComponent };